import {createAsyncThunk} from "@reduxjs/toolkit";
import {setValue} from "./reducers";
import {NowPlaying, PlayerStatus} from "./types";
import {SongPlaySource, track} from "../../../utils/telemetry";

export const updateStatus = createAsyncThunk('player/updateStatus',
    (status: PlayerStatus, {dispatch}) => {
        dispatch(setValue({key: 'status', value: status}));
    }
);

export const updateNowPlaying = createAsyncThunk('player/updateNowPlaying',
    (data: {nowPlaying: NowPlaying, isInitiatedByPlayer: boolean, source?: SongPlaySource}, {dispatch}) => {
        dispatch(setValue({key: 'nowPlaying', value: data.nowPlaying}));
        dispatch(setValue({key: 'isInitiatedByPlayer', value: data.isInitiatedByPlayer}));
        dispatch(setValue({key: 'status', value: 'Playing'}));
        // Only log user-initiated plays. Auto-progressions (next track on song end)
        // would inflate counts and aren't intent signals.
        if (!data.isInitiatedByPlayer) {
            void track('song_play', {
                songId: data.nowPlaying.song.id,
                source: data.source ?? 'unknown',
            });
        }
    }
);

export const updateTotalDuration = createAsyncThunk('player/updateTotalDuration',
    (totalDuration: number, {dispatch}) => {
        dispatch(setValue({key: 'totalDuration', value: totalDuration}));
    }
);

export const updateShuffle = createAsyncThunk('player/updateShuffle',
    (shuffle: boolean, {dispatch}) => {
        dispatch(setValue({key: 'shuffle', value: shuffle}));
    }
);

export type PlayerActions = ReturnType<
    typeof updateStatus | typeof updateNowPlaying | typeof updateTotalDuration | typeof updateShuffle
>;
